import { render } from "./Subscriber.vue?vue&type=template&id=00107f5a"
import script from "./Subscriber.vue?vue&type=script&lang=js"
export * from "./Subscriber.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/resources/shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__